<template>
  <div class="check-in-report relative flex flex-col justify-center items-center">
    <div class="w-full">
      <report-header
        :error.sync="error"
        :range="range"
        :report="report"
        @getReport="getReport"
      >
        <template #title>
          check-in report
        </template>
        <template #subtitle>
          analyze the manual check-ins provided by your staff
        </template>
      </report-header>
    </div>
    <div v-if="loadingReport" class="flex justify-center align-center mt-12">
      <loading-icon />
    </div>
    <div v-else-if="report" class="mt-12 w-full">
      <sb-custom-table
        :rows="tableRows"
        :columns="tableColumns"
        disableTableSort
      />
      <div v-if="pagesTotal > 1" class="flex justify-center items-center mt-10">
        <pagination
          :page.sync="page"
          :pages="pagesTotal"
          :gap="2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { format, subDays } from 'date-fns';
import { utcToZonedTime } from "date-fns-tz";
import { mapGetters } from "vuex";
import { SbCustomTable, Pagination, LoadingIcon } from '@springbig/sb-components';
import { reportsAPI } from '../../services/api/reportsAPI';
import ReportHeader from "./ReportHeader.vue";

export default {
  name: 'CheckInReport',
  components: {
    SbCustomTable,
    LoadingIcon,
    Pagination,
    ReportHeader
  },
  data() {
    return {
      range: null,
      page: 0,
      report: null,
      tableRows: [],
      loadingReport: false,
      tableColumns: [],
      error: {},
    }
  },
  async created() {
    await this.$store.dispatch('LOAD_CURRENT_MERCHANT');
    this.range = this.defaultDateRange();
  },
  watch: {
    page() {
      this.getReport();
    }
  },
  computed: {
    pagesTotal(){
      return this.report?.pagination?.total_pages || 1;
    },
    ...mapGetters(['merchantTimeZone'])
  },
  methods: {
    defaultDateRange() {
      const currentDate = utcToZonedTime(new Date(), this.merchantTimeZone);
      const minimumDate = subDays(currentDate, 90);

      return {
        min: minimumDate,
        start: minimumDate,
        max: subDays(currentDate, 1),
        end: subDays(currentDate, 1)
      }
    },
    async formatReportData() {
      const results = this.report.output_data.results;

      if (results.length > 0) {
        const columns = Object.keys(results[0]).map(key => ({
          key,
          value: key.replace('_', ' '),
        }));
        this.tableColumns = columns;
        this.tableRows = results.map(result => ({
          ...result,
          visit_date: format(utcToZonedTime(new Date(result.visit_date), this.merchantTimeZone), 'MM/dd/yyyy, hh:mmaaa'),
        }));
      }
    },
    createNewReport() {
      return reportsAPI.createReport('Reports::CheckInReport', this.range.start, this.range.end);
    },
    fetchExistingReport() {
      return reportsAPI.getReportById(this.report.id, this.page + 1);
    },
    async getReport(newReport) {
      this.loadingReport = true;
      try {
        const { report, pagination } = !this.report?.id || (this.report.id && newReport)  ? await this.createNewReport()
                                                                                          : await this.fetchExistingReport();
        this.report = { pagination, ...report };
        this.formatReportData();
      } catch(error){
        this.error.message = "error, please refresh or contact support";
      } finally {
        this.loadingReport = false;
      }
    }
  }
}
</script>
